export const SEO = {
  title: "the White Distance",
  description:
    "Tháng thực hành Nghệ thuật | Month of Arts Practice | MAP 2021 | Heritage Space",
  image:
    "https://res.cloudinary.com/goeatme-dev/image/upload/c_scale,w_1200/v1638787036/Background_FB_website_banner_FB_Event_banner_talk_1_cenoiq.jpg",
}
